import React, { ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { SelectableList } from '@/features/ui/SelectableList';
import { InsuranceDataSchema } from '@/features/ui/Steps/InsuranceData/model/types';

import { ServiceCode } from '@/shared/types';
import { Informer, LinkAsButton, Typography } from '@/shared/ui';

import { ResponseInsuranceOrder } from '@/modules/bia/shared/model/types';

import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { formatDate } from '@/helpers/dates';

import { SERVICE_CODES } from '@/lib/consts';

import { MAX_SELECTED_INSURANCE_ORDERS } from '../lib/utils';

type SelectInsuranceViewProps = {
  serviceCode: ServiceCode;
  insuranceOrders: ResponseInsuranceOrder[];
  currentRequestId?: Nullable<string>;
};

const renderInsurance = (insuranceOrder: ResponseInsuranceOrder): ReactElement => {
  return (
    <ul className="insurance-info-item__description">
      <li>Серія та номер: {insuranceOrder.number}</li>
      <li>Дата початку дії: {formatDate(insuranceOrder.date_from)}</li>
      <li>Термін дії: {formatDate(insuranceOrder.date_to)}</li>
    </ul>
  );
};

export const SelectInsuranceView: React.FC<SelectInsuranceViewProps> = ({
  insuranceOrders,
  serviceCode,
  currentRequestId,
}) => {
  const { control } = useFormContext<InsuranceDataSchema>();

  return (
    <>
      <div className="insurance-info">
        <Controller
          name="selectedInsurances"
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <SelectableList<ResponseInsuranceOrder, InsuranceDataSchema['selectedInsurances']>
              inputType="multiple"
              items={insuranceOrders ?? []}
              value={value ?? []}
              onChange={onChange}
              getItemId={(insuranceOrder) => insuranceOrder.id}
              renderItem={renderInsurance}
              containerClassName="insurance-info__container"
              itemClassName="insurance-info__item"
              maxSelected={MAX_SELECTED_INSURANCE_ORDERS}
              errorMessage={error?.message}
            />
          )}
        />
      </div>
      <div className="insurance-banner">
        <Typography variant="H3">
          Не маєте необхідного полісу? <br />
          Придбайте страховку у наших партнерів.
        </Typography>
        <LinkAsButton
          className="insurance-banner__button"
          to={ROUTES_BY_SERVICE_CODE[SERVICE_CODES.INSURANCE]}
          state={{
            redirectServiceLink: ROUTES_BY_SERVICE_CODE[serviceCode],
            redirectServiceRequestId: currentRequestId,
          }}
        >
          Придбати поліс
        </LinkAsButton>
        <Informer
          icon={{
            name: 'attention',
            color: 'blue',
          }}
          text={{
            color: 'black',
            text: 'Після оплати договору страхування ви зможете продовжити роботу зі своєю заявою на послугу',
          }}
          borderColor="blue"
        />
      </div>
    </>
  );
};
